import Cookies from 'js-cookie';
import { adminMainUrl } from "../../../Config.jsx";
import axios from 'axios';

// customer registration data
export const fetchCustomerRegDataRequest = () => ({
    type: "FIND_CUSTOMER_REG_DATA_REQUEST",
});

export const fetchCustomerRegDataSuccess = (data) => ({
    type: "FIND_CUSTOMER_REG_DATA_SUCCESS",
    payload: data,
});

export const fetchCustomerRegDataFailure = (error) => ({
    type: "FIND_CUSTOMER_REG_DATA_FAILURE",
    payload: error,
});

export const getCustomerRegData = (customer_id) => {

    return async function (dispatch) {
        dispatch(fetchCustomerRegDataRequest());
        const token = Cookies.get('token');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'Content-Type': 'application/json',
            }
        };
        // Append the page and items per page to the URL
        const apiUrl = `${adminMainUrl}/api/customer-registration/get?customer_id=${customer_id}`;

        await fetch(apiUrl, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchCustomerRegDataSuccess(resData?.data));

                });
            }).catch((err) => {
                console.log("ERROR in getCustomerRegData function(redux):", err);
                dispatch(fetchCustomerRegDataFailure(err.message));
            });
    };
};

// customer details view
export const fetchCustomerDataRequest = () => ({
    type: "FIND_CUSTOMER_DATA_REQUEST",
});

export const fetchCustomerDataSuccess = (data) => ({
    type: "FIND_CUSTOMER_DATA_SUCCESS",
    payload: data,
});

export const fetchCustomerDataFailure = (error) => ({
    type: "FIND_CUSTOMER_DATA_FAILURE",
    payload: error,
});

export const getCustomerDataAdmin = (customer_id) => {
    return async function (dispatch) {
        dispatch(fetchCustomerDataRequest());
        const token = Cookies.get('token');
        const body = { id: customer_id }
        let config = {
            method: "POST",
            headers: {
                'auth-token': token,
                'user_id': Cookies.get('flexichain_user_id'),
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body)
        };
        // Append the page and items per page to the URL
        const apiUrl = `${adminMainUrl}/api/customer/view`;

        await fetch(apiUrl, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchCustomerDataSuccess(resData?.data));

                });
            }).catch((err) => {
                console.log("ERROR in getCustomerData function(redux):", err);
                dispatch(fetchCustomerDataFailure(err.message));
            });
    };
};
// customer contract list
export const fetchContractListAdminRequest = () => ({
    type: "FIND_CUSTOMER_CONTRACT_LIST_ADMIN_REQUEST",
});

export const fetchContractListAdminSuccess = (data) => ({
    type: "FIND_CUSTOMER_CONTRACT_LIST_ADMIN_SUCCESS",
    payload: data,
});

export const fetchContractListAdminFailure = (error) => ({
    type: "FIND_CUSTOMER_CONTRACT_LIST_ADMIN_FAILURE",
    payload: error,
});

export const getCustomerContractListAdmin = (customer_id) => {
    return async function (dispatch) {
        dispatch(fetchContractListAdminRequest());
        const token = Cookies.get('token');
        const body = { id: customer_id }
        let config = {
            method: "POST",
            headers: {
                'auth-token': token,
                'user_id': Cookies.get('flexichain_user_id'),
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body)
        };
        // Append the page and items per page to the URL
        const apiUrl = `${adminMainUrl}/api/customer/contract/list`;

        await fetch(apiUrl, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchContractListAdminSuccess(resData?.data));

                });
            }).catch((err) => {
                console.log("ERROR in getContractListAdmin function(redux):", err);
                dispatch(fetchContractListAdminFailure(err.message));
            });
    };
};


//contract info for admin
export const fetchContractInfoAdminRequest = () => ({
    type: "FIND_CONTRACT_INFO_ADMIN_REQUEST",
});

export const fetchContractInfoAdminSuccess = (data) => ({
    type: "FIND_CONTRACT_INFO_ADMIN_SUCCESS",
    payload: data,
});

export const fetchContractInfoAdminFailure = (error) => ({
    type: "FIND_CONTRACT_INFO_ADMIN_FAILURE",
    payload: error,
});

export const getContractInfoAdmin = (id) => {
    return async function (dispatch) {
        dispatch(fetchContractInfoAdminRequest());
        const token = Cookies.get('token');
        let reqBody = { "id": id }
        let config = {
            method: "POST",
            headers: {
                'auth-token': token,
                'user_id': Cookies.get('flexichain_user_id'),
                'Content-Type': 'application/json',
            },

        };
        // Append the page and items per page to the URL
        const apiUrl = `${adminMainUrl}/api/customer/contract/view`;

        await axios.post(apiUrl, reqBody, config)
            .then((resData) => {
                // console.log(resData?.data);
                dispatch(fetchContractInfoAdminSuccess(resData?.data?.data));
            }).catch((err) => {
                console.log("ERROR in getContractInfoAdmin function(redux):", err);
                dispatch(fetchContractInfoAdminFailure(err.message));
            });
    };
};


// customer profile data
export const fetchCustomerProfileDataRequest = () => ({
    type: "FIND_CUSTOMER_PROFILE_DATA_REQUEST",
});

export const fetchCustomerProfileDataSuccess = (data) => ({
    type: "FIND_CUSTOMER_PROFILE_DATA_SUCCESS",
    payload: data,
});

export const fetchCustomerProfileDataFailure = (error) => ({
    type: "FIND_CUSTOMER_PROFILE_DATA_FAILURE",
    payload: error,
});

export const getCustomerProfileData = (token) => {

    return async function (dispatch) {
        dispatch(fetchCustomerProfileDataRequest());
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'Content-Type': 'application/json',
            }
        };
        // Append the page and items per page to the URL
        const apiUrl = `${adminMainUrl}/api/customer-profile/get`;

        await fetch(apiUrl, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchCustomerProfileDataSuccess(resData?.data));

                });
            }).catch((err) => {
                console.log("ERROR in getCustomerProfileData function(redux):", err);
                dispatch(fetchCustomerProfileDataFailure(err.message));
            });
    };
};




// customer profile data for user
// customer profile data
export const fetchCustomerUpdateProfileDataRequest = () => ({
    type: "FIND_CUSTOMER_UPDATE_PROFILE_DATA_REQUEST",
});

export const fetchCustomerUpdateProfileDataSuccess = (data) => ({
    type: "FIND_CUSTOMER_UPDATE_PROFILE_DATA_SUCCESS",
    payload: data,
});

export const fetchCustomerUpdateProfileDataFailure = (error) => ({
    type: "FIND_CUSTOMER_UPDATE_PROFILE_DATA_FAILURE",
    payload: error,
});

export const getCustomerUpdateProfileData = (token) => {
    return async function (dispatch) {
        dispatch(fetchCustomerUpdateProfileDataRequest());
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'Content-Type': 'application/json',
            }
        };
        // Append the page and items per page to the URL
        const apiUrl = `${adminMainUrl}/api/customer-profile/get`;

        await fetch(apiUrl, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchCustomerUpdateProfileDataSuccess(resData?.data));

                });
            }).catch((err) => {
                console.log("ERROR in getCustomerUpdateProfileData function(redux):", err);
                dispatch(fetchCustomerUpdateProfileDataFailure(err.message));
            });
    };
};

// customer profile document fields
export const fetchCustomerProfileDocumentFieldsRequest = () => ({
    type: "FIND_CUSTOMER_PROFILE_DOCUMENT_FIELDS_REQUEST",
});

export const fetchCustomerProfileDocumentFieldsSuccess = (data) => ({
    type: "FIND_CUSTOMER_PROFILE_DOCUMENT_FIELDS_SUCCESS",
    payload: data,
});

export const fetchCustomerProfileDocumentFieldsFailure = (error) => ({
    type: "FIND_CUSTOMER_PROFILE_DOCUMENT_FIELDS_FAILURE",
    payload: error,
});

export const getCustomerProfileDocumentFields = () => {

    return async function (dispatch) {
        dispatch(fetchCustomerProfileDocumentFieldsRequest());
        const token = Cookies.get('customertoken');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'Content-Type': 'application/json',
            }
        };
        // Append the page and items per page to the URL
        const apiUrl = `${adminMainUrl}/api/customer-profile/document-fields`;

        await fetch(apiUrl, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchCustomerProfileDocumentFieldsSuccess(resData));
                });
            }).catch((err) => {
                console.log("ERROR in getCustomerProfileDocumentFields function(redux):", err);
                dispatch(fetchCustomerProfileDocumentFieldsFailure(err.message));
            });
    };
};


// customer contract List
export const fetchCustomerContractsRequest = () => ({
    type: "FIND_CUSTOMER_CONTRACTS_REQUEST",
});

export const fetchCustomerContractsSuccess = (data) => ({
    type: "FIND_CUSTOMER_CONTRACTS_SUCCESS",
    payload: data,
});

export const fetchCustomerContractsFailure = (error) => ({
    type: "FIND_CUSTOMER_CONTRACTS_FAILURE",
    payload: error,
});

export const getCustomerContracts = () => {

    return async function (dispatch) {
        dispatch(fetchCustomerContractsRequest());
        const token = Cookies.get('customertoken');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'Content-Type': 'application/json',
            }
        };
        // Append the page and items per page to the URL
        const apiUrl = `${adminMainUrl}/api/customer/contract-list`;

        await fetch(apiUrl, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchCustomerContractsSuccess(resData?.data));
                });
            }).catch((err) => {
                console.log("ERROR in getCustomerContracts function(redux):", err);
                dispatch(fetchCustomerContractsFailure(err.message));
            });
    };
};

// customer reg document fields
export const fetchCustomerProfileDocumentListRequest = () => ({
    type: "FIND_CUSTOMER_PROFILE_DOCUMENT_LIST_REQUEST",
});

export const fetchCustomerProfileDocumentListSuccess = (data) => ({
    type: "FIND_CUSTOMER_PROFILE_DOCUMENT_LIST_SUCCESS",
    payload: data,
});

export const fetchCustomerProfileDocumentListFailure = (error) => ({
    type: "FIND_CUSTOMER_PROFILE_DOCUMENT_LIST_FAILURE",
    payload: error,
});

export const getCustomerProfileDocumentList = () => {

    return async function (dispatch) {
        dispatch(fetchCustomerProfileDocumentListRequest());
        const token = Cookies.get('customertoken');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'Content-Type': 'application/json',
            }
        };
        // Append the page and items per page to the URL
        const apiUrl = `${adminMainUrl}/api/customer-profile/get-document-list`;

        await fetch(apiUrl, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchCustomerProfileDocumentListSuccess(resData?.data));
                });
            }).catch((err) => {
                console.log("ERROR in getCustomerProfileDocumentList function(redux):", err);
                dispatch(fetchCustomerProfileDocumentListFailure(err.message));
            });
    };
};

// customer contract info
export const fetchContractInfoRequest = () => ({
    type: "FIND_CONTRACT_INFO_REQUEST",
});

export const fetchContractInfoSuccess = (data) => ({
    type: "FIND_CONTRACT_INFO_SUCCESS",
    payload: data,
});

export const fetchContractInfoFailure = (error) => ({
    type: "FIND_CONTRACT_INFO_FAILURE",
    payload: error,
});

export const getContractInfo = (id) => {

    return async function (dispatch) {
        dispatch(fetchContractInfoRequest());
        const token = Cookies.get('customertoken');
        let reqBody = { "id": id }
        let config = {
            method: "POST",
            headers: {
                'auth-token': token,
                'Content-Type': 'application/json',
            },

        };
        // Append the page and items per page to the URL
        const apiUrl = `${adminMainUrl}/api/customer/contract-view`;

        await axios.post(apiUrl, reqBody, config)
            .then((resData) => {
                dispatch(fetchContractInfoSuccess(resData?.data?.data));
            }).catch((err) => {
                console.log("ERROR in getContractInfo function(redux):", err);
                dispatch(fetchContractInfoFailure(err.message));
            });
    };
};



// customer reg document fields
export const fetchCustomerDocumentFieldsRequest = () => ({
    type: "FIND_CUSTOMER_DOCUMENT_FIELDS_REQUEST",
});

export const fetchCustomerDocumentFieldsSuccess = (data) => ({
    type: "FIND_CUSTOMER_DOCUMENT_FIELDS_SUCCESS",
    payload: data,
});

export const fetchCustomerDocumentFieldsFailure = (error) => ({
    type: "FIND_CUSTOMER_DOCUMENT_FIELDS_FAILURE",
    payload: error,
});

export const getCustomerDocumentFields = (customer_id) => {

    return async function (dispatch) {
        dispatch(fetchCustomerDocumentFieldsRequest());
        const token = Cookies.get('token');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': Cookies.get('flexichain_user_id'),
                'Content-Type': 'application/json',
            }
        };
        // Append the page and items per page to the URL
        const apiUrl = `${adminMainUrl}/api/customer-registration/document-fields?customer_id=${customer_id}`;

        await fetch(apiUrl, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchCustomerDocumentFieldsSuccess(resData));
                });
            }).catch((err) => {
                console.log("ERROR in getCustomerDocumentFields function(redux):", err);
                dispatch(fetchCustomerDocumentFieldsFailure(err.message));
            });
    };
};


// CUStomer list
export const fetchCustomerListRequest = () => ({
    type: "FIND_CUSTOMER_LIST_REQUEST",
});

export const fetchCustomerListSuccess = (data) => ({
    type: "FIND_CUSTOMER_LIST_SUCCESS",
    payload: data,
});

export const fetchCustomerListFailure = (error) => ({
    type: "FIND_CUSTOMER_LIST_FAILURE",
    payload: error,
});

export const getCustomerList = (token, user_id, current_page, search_by, get_customer_id) => {
    return async function (dispatch) {
        dispatch(fetchCustomerListRequest());
        const token = Cookies.get('token');

        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        let apiUrl = `${adminMainUrl}/api/customer/list`;

        // Build query parameters dynamically
        const queryParams = new URLSearchParams();
        if (current_page) queryParams.append("page", current_page);
        if (search_by) queryParams.append("search_by", search_by);
        if (get_customer_id) queryParams.append('parent_agent_id', get_customer_id);

        // Append query params if any exist
        if ([...queryParams].length) {
            apiUrl += `?${queryParams.toString()}`;
        }

        await fetch(apiUrl, config)
            .then((res) => res.json())
            .then((resData) => {
                dispatch(fetchCustomerListSuccess(resData));
            })
            .catch((err) => {
                console.log("ERROR in getCustomerList function(redux):", err);
                dispatch(fetchCustomerListFailure(err.message));
            });
    };
};



// Applicable Slab list
export const fetchApplicableSlabListRequest = () => ({
    type: "FIND_APPLICABLE_SLAB_LIST_REQUEST",
});

export const fetchApplicableSlabListSuccess = (data) => ({
    type: "FIND_APPLICABLE_SLAB_LIST_SUCCESS",
    payload: data,
});

export const fetchApplicableSlabListFailure = (error) => ({
    type: "FIND_APPLICABLE_SLAB_LIST_FAILURE",
    payload: error,
});

export const getApplicableSlabList = () => {

    return async function (dispatch) {
        dispatch(fetchApplicableSlabListRequest());
        const token = Cookies.get('token');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'Content-Type': 'application/json',
            }
        };
        // Append the page and items per page to the URL
        const apiUrl = `${adminMainUrl}/api/applicableslab/get`;

        await fetch(apiUrl, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchApplicableSlabListSuccess(resData));

                });
            }).catch((err) => {
                console.log("ERROR in getApplicableSlabList function(redux):", err);
                dispatch(fetchApplicableSlabListFailure(err.message));
            });
    };
};


// Applicable Slab view
export const fetchApplicableSlabViewRequest = () => ({
    type: "FIND_APPLICABLE_SLAB_VIEW_REQUEST",
});

export const fetchApplicableSlabViewSuccess = (data) => ({
    type: "FIND_APPLICABLE_SLAB_VIEW_SUCCESS",
    payload: data,
});

export const fetchApplicableSlabViewFailure = (error) => ({
    type: "FIND_APPLICABLE_SLAB_VIEW_FAILURE",
    payload: error,
});

export const getApplicableSlabView = () => {

    return async function (dispatch) {
        dispatch(fetchApplicableSlabViewRequest());
        const token = Cookies.get('token');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'Content-Type': 'application/json',
            }
        };
        // Append the page and items per page to the URL
        const apiUrl = `${adminMainUrl}/api/applicableslab/view`;

        await fetch(apiUrl, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchApplicableSlabViewSuccess(resData));

                });
            }).catch((err) => {
                console.log("ERROR in getApplicableSlabView function(redux):", err);
                dispatch(fetchApplicableSlabViewFailure(err.message));
            });
    };
};


// Airline list
export const fetchAirlineMasterListRequest = () => ({
    type: "FIND_AIRLINE_MASTER_LIST_REQUEST",
});

export const fetchAirlineMasterListSuccess = (data) => ({
    type: "FIND_AIRLINE_MASTER_LIST_SUCCESS",
    payload: data,
});

export const fetchAirlineMasterListFailure = (error) => ({
    type: "FIND_AIRLINE_MASTER_LIST_FAILURE",
    payload: error,
});

export const getAirlineMasterList = () => {

    return async function (dispatch) {
        dispatch(fetchAirlineMasterListRequest());
        const token = Cookies.get('token');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'Content-Type': 'application/json',
            }
        };
        // Append the page and items per page to the URL
        const apiUrl = `${adminMainUrl}/api/airline/get`;

        await fetch(apiUrl, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchAirlineMasterListSuccess(resData));

                });
            }).catch((err) => {
                console.log("ERROR in getAirlineMasterList function(redux):", err);
                dispatch(fetchAirlineMasterListFailure(err.message));
            });
    };
};



// airline master view
export const fetchAirlineMasterViewRequest = () => ({
    type: "FIND_AIRLINE_MASTER_VIEW_REQUEST",
});

export const fetchAirlineMasterViewSuccess = (data) => ({
    type: "FIND_AIRLINE_MASTER_VIEW_SUCCESS",
    payload: data,
});

export const fetchAirlineMasterViewFailure = (error) => ({
    type: "FIND_AIRLINE_MASTER_VIEW_FAILURE",
    payload: error,
});

export const getAirlineMasterView = () => {

    return async function (dispatch) {
        dispatch(fetchAirlineMasterViewRequest());
        const token = Cookies.get('token');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'Content-Type': 'application/json',
            }
        };
        // Append the page and items per page to the URL
        const apiUrl = `${adminMainUrl}/api/airline/view`;

        await fetch(apiUrl, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchAirlineMasterViewSuccess(resData));

                });
            }).catch((err) => {
                console.log("ERROR in getAirlineMasterView function(redux):", err);
                dispatch(fetchAirlineMasterViewFailure(err.message));
            });
    };
};


// customer reg document fields
export const fetchCustomerDocumentListRequest = () => ({
    type: "FIND_CUSTOMER_DOCUMENT_LIST_REQUEST",
});

export const fetchCustomerDocumentListSuccess = (data) => ({
    type: "FIND_CUSTOMER_DOCUMENT_LIST_SUCCESS",
    payload: data,
});

export const fetchCustomerDocumentListFailure = (error) => ({
    type: "FIND_CUSTOMER_DOCUMENT_LIST_FAILURE",
    payload: error,
});

export const getCustomerDocumentList = (customer_id) => {

    return async function (dispatch) {
        dispatch(fetchCustomerDocumentListRequest());
        const token = Cookies.get('token');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': Cookies.get('flexichain_user_id'),
                'Content-Type': 'application/json',
            }
        };
        // Append the page and items per page to the URL
        const apiUrl = `${adminMainUrl}/api/customer/get-document-list?customer_id=${customer_id}`;

        await fetch(apiUrl, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchCustomerDocumentListSuccess(resData?.data));
                });
            }).catch((err) => {
                console.log("ERROR in getCustomerDocumentList function(redux):", err);
                dispatch(fetchCustomerDocumentListFailure(err.message));
            });
    };
};

export const fetchDashboardGraphDropdown = (data) => ({
    type: "FIND_DASHBOARD_DROPDOWN",
    payload: data,
});

export const getDashboardGraphDropdown = (year, user_id) => {
    return async function (dispatch) {
        let data;
        if (year == new Date().getFullYear()) {
            data = ['Last Week', 'Monthly', 'Half Yearly', 'Yearly'];
        } else {
            data = ['Monthly', 'Half Yearly', 'Yearly'];
        }

        dispatch(fetchDashboardGraphDropdown(data));
    };
};

export const fetchDashboardSecondGraphDropdown = (data) => ({
    type: "FIND_DASHBOARD_SECOND_DROPDOWN",
    payload: data,
});

export const getDashboardSecondGraphDropdown = (year) => {
    return async function (dispatch) {
        let data;
        if (year == new Date().getFullYear()) {
            data = ['Last Week', 'Yearly'];
        } else {
            data = ['Yearly'];
        }

        dispatch(fetchDashboardSecondGraphDropdown(data));
    };
};


// admin dashboard
export const fetchAdminDashboardCounterRequest = () => ({
    type: "FIND_ADMIN_DASHBOARD_COUNTER_REQUEST",
});

export const fetchAdminDashboardCounterSuccess = (data) => ({
    type: "FIND_ADMIN_DASHBOARD_COUNTER_SUCCESS",
    payload: data,
});

export const fetchAdminDashboardCounterFailure = (error) => ({
    type: "FIND_ADMIN_DASHBOARD_COUNTER_FAILURE",
    payload: error,
});

export const getAdminDashboardCounter = (year, user_id) => {

    return async function (dispatch) {
        dispatch(fetchAdminDashboardCounterRequest());
        const token = Cookies.get('token');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        // Append the page and items per page to the URL
        const apiUrl = `${adminMainUrl}/api/admin-dashboard-data?year=${year}`;

        await fetch(apiUrl, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchAdminDashboardCounterSuccess(resData));
                });
            }).catch((err) => {
                console.log("ERROR in getAdminDashboardCounter function(redux):", err);
                dispatch(fetchAdminDashboardCounterFailure(err.message));
            });
    };
};

// admin dashboard all leads graph
export const fetchAdminDashboardAllLeadsGraphRequest = () => ({
    type: "FIND_ADMIN_DASHBOARD_ALL_LEAD_GRAPHS_REQUEST",
});

export const fetchAdminDashboardAllLeadsGraphSuccess = (data) => ({
    type: "FIND_ADMIN_DASHBOARD_ALL_LEAD_GRAPHS_SUCCESS",
    payload: data,
});

export const fetchAdminDashboardAllLeadsGraphFailure = (error) => ({
    type: "FIND_ADMIN_DASHBOARD_ALL_LEAD_GRAPHS_FAILURE",
    payload: error,
});

export const getAdminDashboardAllLeadsGraph = (year, user_id) => {

    return async function (dispatch) {
        dispatch(fetchAdminDashboardAllLeadsGraphRequest());
        const token = Cookies.get('token');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        // Append the page and items per page to the URL
        const apiUrl = `${adminMainUrl}/api/admin-dashboard-all-leads?year=${year}`;

        await fetch(apiUrl, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchAdminDashboardAllLeadsGraphSuccess(resData));
                });
            }).catch((err) => {
                console.log("ERROR in getAdminDashboardAllLeadsGraph function(redux):", err);
                dispatch(fetchAdminDashboardAllLeadsGraphFailure(err.message));
            });
    };
};


// admin dashboard all leads graph
export const fetchAdminDashboardTotalQueryGraphRequest = () => ({
    type: "FIND_ADMIN_DASHBOARD_TOTAL_QUERY_GRAPHS_REQUEST",
});

export const fetchAdminDashboardTotalQueryGraphSuccess = (data) => ({
    type: "FIND_ADMIN_DASHBOARD_TOTAL_QUERY_GRAPHS_SUCCESS",
    payload: data,
});

export const fetchAdminDashboardTotalQueryGraphFailure = (error) => ({
    type: "FIND_ADMIN_DASHBOARD_TOTAL_QUERY_GRAPHS_FAILURE",
    payload: error,
});

export const getAdminDashboardTotalQueryGraph = (year, user_id) => {

    return async function (dispatch) {
        dispatch(fetchAdminDashboardTotalQueryGraphRequest());
        const token = Cookies.get('token');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                "user_id": user_id,
                'Content-Type': 'application/json',
            }
        };
        // Append the page and items per page to the URL
        const apiUrl = `${adminMainUrl}/api/admin-dashboard-total-query?year=${year}`;

        await fetch(apiUrl, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchAdminDashboardTotalQueryGraphSuccess(resData));
                });
            }).catch((err) => {
                console.log("ERROR in getAdminDashboardTotalQueryGraph function(redux):", err);
                dispatch(fetchAdminDashboardTotalQueryGraphFailure(err.message));
            });
    };
};


// Sales/Crm dashboard
export const fetchSalesCrmDashboardCounterRequest = () => ({
    type: "FIND_SALES_CRM_DASHBOARD_COUNTER_REQUEST",
});

export const fetchSalesCrmDashboardCounterSuccess = (data) => ({
    type: "FIND_SALES_CRM_DASHBOARD_COUNTER_SUCCESS",
    payload: data,
});

export const fetchSalesCrmDashboardCounterFailure = (error) => ({
    type: "FIND_SALES_CRM_DASHBOARD_COUNTER_FAILURE",
    payload: error,
});

export const getSalesCrmDashboardCounter = (year, user_id) => {

    return async function (dispatch) {
        dispatch(fetchSalesCrmDashboardCounterRequest());
        const token = Cookies.get('token');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        // Append the page and items per page to the URL
        const apiUrl = `${adminMainUrl}/api/sales-crm-dashboard-data?year=${year}`;

        await fetch(apiUrl, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchSalesCrmDashboardCounterSuccess(resData));
                });
            }).catch((err) => {
                console.log("ERROR in getSalesCrmDashboardCounter function(redux):", err);
                dispatch(fetchSalesCrmDashboardCounterFailure(err.message));
            });
    };
};

// Sales/Crm dashboard all leads graph
export const fetchSalesCrmDashboardAllLeadsGraphRequest = () => ({
    type: "FIND_SALES_CRM_DASHBOARD_ALL_LEAD_GRAPHS_REQUEST",
});

export const fetchSalesCrmDashboardAllLeadsGraphSuccess = (data) => ({
    type: "FIND_SALES_CRM_DASHBOARD_ALL_LEAD_GRAPHS_SUCCESS",
    payload: data,
});

export const fetchSalesCrmDashboardAllLeadsGraphFailure = (error) => ({
    type: "FIND_SALES_CRM_DASHBOARD_ALL_LEAD_GRAPHS_FAILURE",
    payload: error,
});

export const getSalesCrmDashboardAllLeadsGraph = (year, user_id) => {

    return async function (dispatch) {
        dispatch(fetchSalesCrmDashboardAllLeadsGraphRequest());
        const token = Cookies.get('token');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'Content-Type': 'application/json',
                'user_id': user_id
            }
        };
        // Append the page and items per page to the URL
        const apiUrl = `${adminMainUrl}/api/sales-crm-dashboard-all-leads?year=${year}`;

        await fetch(apiUrl, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchSalesCrmDashboardAllLeadsGraphSuccess(resData));
                });
            }).catch((err) => {
                console.log("ERROR in getSalesCrmDashboardAllLeadsGraph function(redux):", err);
                dispatch(fetchSalesCrmDashboardAllLeadsGraphFailure(err.message));
            });
    };
};


// Sales/Crm dashboard all leads graph
export const fetchSalesCrmDashboardTotalQueryGraphRequest = () => ({
    type: "FIND_SALES_CRM_DASHBOARD_TOTAL_QUERY_GRAPHS_REQUEST",
});

export const fetchSalesCrmDashboardTotalQueryGraphSuccess = (data) => ({
    type: "FIND_SALES_CRM_DASHBOARD_TOTAL_QUERY_GRAPHS_SUCCESS",
    payload: data,
});

export const fetchSalesCrmDashboardTotalQueryGraphFailure = (error) => ({
    type: "FIND_SALES_CRM_DASHBOARD_TOTAL_QUERY_GRAPHS_FAILURE",
    payload: error,
});

export const getSalesCrmDashboardTotalQueryGraph = (year, user_id) => {

    return async function (dispatch) {
        dispatch(fetchSalesCrmDashboardTotalQueryGraphRequest());
        const token = Cookies.get('token');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        // Append the page and items per page to the URL
        const apiUrl = `${adminMainUrl}/api/sales-crm-dashboard-total-query?year=${year}`;

        await fetch(apiUrl, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchSalesCrmDashboardTotalQueryGraphSuccess(resData));
                });
            }).catch((err) => {
                console.log("ERROR in getSalesCrmDashboardTotalQueryGraph function(redux):", err);
                dispatch(fetchSalesCrmDashboardTotalQueryGraphFailure(err.message));
            });
    };
};


// Pricing dashboard
export const fetchPricingDashboardCounterRequest = () => ({
    type: "FIND_PRICING_DASHBOARD_COUNTER_REQUEST",
});

export const fetchPricingDashboardCounterSuccess = (data) => ({
    type: "FIND_PRICING_DASHBOARD_COUNTER_SUCCESS",
    payload: data,
});

export const fetchPricingDashboardCounterFailure = (error) => ({
    type: "FIND_PRICING_DASHBOARD_COUNTER_FAILURE",
    payload: error,
});

export const getPricingDashboardCounter = (year) => {

    return async function (dispatch) {
        dispatch(fetchPricingDashboardCounterRequest());
        const token = Cookies.get('token');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'Content-Type': 'application/json',
            }
        };
        // Append the page and items per page to the URL
        const apiUrl = `${adminMainUrl}/api/pricing-dashboard-data?year=${year}`;

        await fetch(apiUrl, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchPricingDashboardCounterSuccess(resData));
                });
            }).catch((err) => {
                console.log("ERROR in getPricingDashboardCounter function(redux):", err);
                dispatch(fetchPricingDashboardCounterFailure(err.message));
            });
    };
};

// Pricing dashboard all leads graph
export const fetchPricingDashboardAllLeadsGraphRequest = () => ({
    type: "FIND_PRICING_DASHBOARD_ALL_LEAD_GRAPHS_REQUEST",
});

export const fetchPricingDashboardAllLeadsGraphSuccess = (data) => ({
    type: "FIND_PRICING_DASHBOARD_ALL_LEAD_GRAPHS_SUCCESS",
    payload: data,
});

export const fetchPricingDashboardAllLeadsGraphFailure = (error) => ({
    type: "FIND_PRICING_DASHBOARD_ALL_LEAD_GRAPHS_FAILURE",
    payload: error,
});

export const getPricingDashboardAllLeadsGraph = (year) => {

    return async function (dispatch) {
        dispatch(fetchPricingDashboardAllLeadsGraphRequest());
        const token = Cookies.get('token');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'Content-Type': 'application/json',
            }
        };
        // Append the page and items per page to the URL
        const apiUrl = `${adminMainUrl}/api/pricing-dashboard-all-leads?year=${year}`;

        await fetch(apiUrl, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchPricingDashboardAllLeadsGraphSuccess(resData));
                });
            }).catch((err) => {
                console.log("ERROR in getPricingDashboardAllLeadsGraph function(redux):", err);
                dispatch(fetchPricingDashboardAllLeadsGraphFailure(err.message));
            });
    };
};


// Pricing dashboard all leads graph
export const fetchCustomerQuotationListRequest = () => ({
    type: "FIND_CUSTOMER_QUOTATION_LIST_REQUEST",
});

export const fetchCustomerQuotationListSuccess = (data) => ({
    type: "FIND_CUSTOMER_QUOTATION_LIST_SUCCESS",
    payload: data,
});

export const fetchCustomerQuotationListFailure = (error) => ({
    type: "FIND_CUSTOMER_QUOTATION_LIST_FAILURE",
    payload: error,
});

export const getCustomerQuotationList = (userName) => {

    return async function (dispatch) {
        dispatch(fetchCustomerQuotationListRequest());
        const token = Cookies.get('token');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'Content-Type': 'application/json',
            }
        };
        // Append the page and items per page to the URL
        const apiUrl = `${adminMainUrl}/api/customer-profile/get-customer-quotation-list?userName=${userName}`;

        await fetch(apiUrl, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchCustomerQuotationListSuccess(resData));
                });
            }).catch((err) => {
                console.log("ERROR in getCustomerQuotationList function(redux):", err);
                dispatch(fetchCustomerQuotationListFailure(err.message));
            });
    };
};


//Lead list
export const fetchCustomerLeadStatusRequest = () => ({
    type: "FIND_LEAD_STATUS_REQUEST",
});

export const fetchCustomerLeadStatusSuccess = (data) => ({
    type: "FIND_LEAD_STATUS_SUCCESS",
    payload: data,
});

export const fetchCustomerLeadStatusFailure = (error) => ({
    type: "FIND_LEAD_STATUS_FAILURE",
    payload: error,
});

export const getCustomerLeadStatus = (token, current_page, queryParams) => {

    return async function (dispatch) {
        dispatch(fetchCustomerLeadStatusRequest());
        let params = new URLSearchParams(queryParams);
        let requestBody = {
            destination: "",
            email: "",
            end_date: null,
            name: "",
            origin: "",
            phone: "",
            request_no: "",
            required_servie_id: "",
            search_by: "",
            shipment_type_id: "",
            shipment_via_id: "",
            start_date: null,
        };
        params.forEach((value, key) => {
            requestBody[key] = value;
        });

        params.delete('page');  // Remove the page from the query params

        let config = {
            method: "POST",
            headers: {
                'auth-token': token,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestBody)
        };
        if (!current_page) {
            current_page = 1;
        }


        let apiUrl = `${adminMainUrl}/api/customer-query-list?page=${current_page}`

        await fetch(apiUrl, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchCustomerLeadStatusSuccess(resData));
                });
            }).catch((err) => {
                console.log("ERROR in getCustomerLeadStatus function(redux):", err);
                fetchCustomerLeadStatusFailure(err.message);
            });
    };
};



//get Quotation/Lead Info

export const fetchCustomerQuoteDetailRequest = () => ({
    type: "FIND_CUSTOMER_QUOTE_DETAIL_REQUEST",
});

export const fetchCustomerQuoteDetailSuccess = (data) => ({
    type: "FIND_CUSTOMER_QUOTE_DETAIL_SUCCESS",
    payload: data,
});

export const fetchCustomerQuoteDetailFailure = (error) => ({
    type: "FIND_CUSTOMER_QUOTE_DETAIL_FAILURE",
    payload: error,
});

export const getCustomerQuoteDetail = (token, id) => {
    return async function (dispatch) {
        dispatch(fetchCustomerQuoteDetailRequest());
        let config = {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'auth-token': token,
            },
            body: JSON.stringify({ quotation_id: id })
        };
        await fetch(`${adminMainUrl}/api/customer-query-view`, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchCustomerQuoteDetailSuccess(resData.data));
                })
            }).catch((err) => {
                dispatch(fetchCustomerQuoteDetailFailure(err.message));
                console.log("ERROR in getCustomerQuoteDetail function(redux):", err);
            });
    };
};


//get Quotation/Lead Info